import { createApi, BaseQueryFn, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { GRAPH_QL_ENDPOINT } from '@constants/constants';
import { appInsights } from '@/telemetry/client';

// If ErrorResponse is a custom type, ensure it's properly imported.
// Otherwise, FetchBaseQueryError could be used, or create a custom error type if needed.
type ErrorResponse = FetchBaseQueryError | { status: number; data: unknown } | { message: string; stack: string; name: string };

const baseQuery = graphqlRequestBaseQuery({
  url: GRAPH_QL_ENDPOINT,
  prepareHeaders: (headers, { extra }: { extra: any }) => {
    const token = extra?.cookies['cl_token'] ?? null;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    headers.set('sc_apikey', '{8031511F-8688-4591-857F-4E9C851EC5EA}');
    return headers;
  }
});

// Updated typings for baseQueryWithErrorHandling
const baseQueryWithErrorHandling: BaseQueryFn<
  Parameters<typeof baseQuery>[0], // Argument type: the first parameter to baseQuery
  unknown, // Return type
  ErrorResponse // Error type (adjusted to match actual error type)
> = async (...args) => {
  const result = await baseQuery(...args);
  if (result.error) {
    console.log('Error in contentApi: ', result.error);
    appInsights.trackException({ exception: result.error });
  }
  return result;
};

export const graphqlBaseApi = createApi({
  reducerPath: 'gql',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: () => ({})
});
